import { Node, mergeAttributes } from '@tiptap/core';

/**
 * A call-to-action button block in the scratch pad: one atomic block with a label, a link and an
 * alignment, shown as the navy pill the mail will carry. Saved as
 * <a data-button="1" data-align="…" href="…">Label</a>; the server turns that into the
 * Outlook-safe table button (scratchEmail.ts#buttonTables).
 */
export const CtaButton = Node.create({
  name: 'ctaButton',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      label: {
        default: 'Open',
        parseHTML: (el) => el.textContent?.trim() || 'Open',
        renderHTML: () => ({}),
      },
      href: {
        default: '',
        parseHTML: (el) => el.getAttribute('href') ?? '',
        renderHTML: (attrs) => ({ href: attrs.href }),
      },
      align: {
        default: 'left',
        parseHTML: (el) => el.getAttribute('data-align') || 'left',
        renderHTML: (attrs) => ({ 'data-align': attrs.align }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'a[data-button]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'a',
      mergeAttributes(HTMLAttributes, {
        'data-button': '1',
        class: `sp-cta sp-cta-${node.attrs.align}`,
        contenteditable: 'false',
        title: node.attrs.href ? `Button → ${node.attrs.href}` : 'Button (no link yet)',
      }),
      node.attrs.label,
    ];
  },

  renderText({ node }) {
    return `[${node.attrs.label}](${node.attrs.href})`;
  },

  addCommands() {
    return {
      insertCta:
        (attrs) =>
        ({ chain }) =>
          chain()
            .insertContent([{ type: this.name, attrs }, { type: 'paragraph' }])
            .run(),
      updateCta:
        (attrs) =>
        ({ commands }) =>
          commands.updateAttributes(this.name, attrs),
    };
  },
});

export default CtaButton;
